export const GRID_ELEMENT = 'grid_element'
export const LIST_ELEMENT = 'list_element'
export const SHOWTIMES_ELEMENT = 'showtimes_element'
export const FRONTPAGE_SANDWICH_ELEMENT = 'frontpage_sandwichelement_element'
export const FRONTPAGE_DESKTOP_ELEMENT = 'frontpage_desktop_element'
export const OVERVIEW_ELEMENT = 'overview_element'
export const BUTTON = 'button'